<i18n lang='yml' src='../i18n/ContainerSelection.yml'></i18n>
<template>

  <div>
    <multi-select
      v-model="auto_register_containers"
      :options="dropDownContainers"
      label="label"
      key="value"
      mode="tags"
      :close-on-select="false"
      :hideSelected="false"
      :searchable="true"
      :create-option="false"
      :canClear="true"
    />
    <input type="hidden" v-for="c in auto_register_containers" :key="c" id="invitation_code_auto_register_containers" :value="c" 
    :name="input_name"/>
  </div>
</template>
<script>  
  export default {
    props: {
      containers: String,
      input_name: String,
      clear: Boolean
    },
    watch: {  
      clear(newVal){
        if(newVal) {
          this.auto_register_containers = [];
        }
      }
    },
    data() {
      return {
        auto_register_containers: []
      }
    },
    computed: {
      dropDownContainers() {
        let results = [];
        try{
          JSON.parse(this.containers).forEach((container) => {
            // Container id is container[0] container name is container[1]
            // debugger
            results.push({value: container[0], label: container[1]});
          })
        } catch(error) {
          console.log("ERROR: Couldn't parse containers for selection");
        }
        return results;
      }
    },
  }
</script>
